import { useEffect } from 'react';
import { useCookieConsent } from '../context/CookieConsentContext';
import { analytics } from '../firebase';
import { setAnalyticsCollectionEnabled } from 'firebase/analytics';

const AnalyticsInitializer = () => {
  const { allowAnalytics, hasMadeChoice } = useCookieConsent();

  useEffect(() => {
    // We only act once the user has made a choice.
    if (hasMadeChoice) {
      if (analytics) {
        console.log(`Setting analytics collection to: ${allowAnalytics}`);
        setAnalyticsCollectionEnabled(analytics, allowAnalytics);
      }
    }
  }, [allowAnalytics, hasMadeChoice]);

  return null; // This component does not render anything.
};

export default AnalyticsInitializer;
